"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
rxjs_1.Observable.generate = rxjs_1.generate;
//# sourceMappingURL=generate.js.map